import type { FamilyLinks } from "../../../model/family-links.ts";
import { COMPARISON_PAGES } from "./comparison-pages.ts";
import { COMPARISONS_WORDS_EN as EN } from "./comparisons-words-en.ts";
import { COMPARISONS_WORDS_ES as ES } from "./comparisons-words-es.ts";

// The comparisons family's pages, for the footer and other pages' bodies: one entry per page, its
// label from the page's two words files.
export const COMPARISON_LINKS: FamilyLinks = {
  title: { en: EN.footerTitle, es: ES.footerTitle },
  links: COMPARISON_PAGES.map((page) => ({
    label: { en: page.words.en.linkLabel, es: page.words.es.linkLabel },
    href: page.path,
  })),
};
